"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const en_US_1 = tslib_1.__importDefault(require("date-fns/locale/en-US"));
const enUS = {
    ...en_US_1.default,
    options: {
        ...en_US_1.default.options,
        /* We want to force the week to start on monday */
        weekStartsOn: 1 /* Monday */,
    },
};
exports.default = enUS;
